module.exports = __webpack_public_path__ + "static/media/blog-2.8e6cd66a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/blog-2.jpg
// module id = 843
// module chunks = 0